import ImageIcon from "../../images/default_image_new_icon.svg";
// import VideoIcon from "../../images/BlockVideoDefault.svg";
import Structure from "../../images/default-structure-new-icon.svg";
import StructureActive from "../../images/active-structure-new-icon.svg";
import Link from "../../images/BlocklinkDefault.svg";
import ButtonDefault from "../../images/default_button_new_icon.svg";
//import Dropdown from "../../images/Dropdown.svg";
import TabIcon from "../../images/BlockTabsDefault.svg";
import Scroll from "../../images/Scroll.svg";
import TableIcon from "../../images/default_table_tabs_new_icon.svg";
import TextIcon from "../../images/default_text_new_icon.svg";
import ImageIconDefault from "../../images/default_image_new_icon.svg";
import InActiveFormIcon from "../../images/default_forms_new_icon.svg";
import ActiveFormIcon from "../../images/active_forms_new_icon.svg";
import InActiveStructureIcon from "../../images/default-structure-new-icon.svg";
import BlockTextActive from "../../images/active-text-new-icon.svg";
import ActiveExtraBlock from "../../images/active_other_tools_new_icon.svg";
import InActiveExtraBlock from "../../images/default_other_tools_new_icon.svg";
import ActiveImageBlock from "../../images/active_image_new_icon.svg";
import ActiveTableBlock from "../../images/active_table_tabs_new_icon.svg";
import ActiveLinkBlock from "../../images/active_link_new_icon.svg";
import ActivePopUpBlockIcon from "../../images/customPopup/ActivePopUpBlockIcon.svg";
import InActivePopUpBlockIcon from "../../images/customPopup/InActivePopUpBlockIcon.svg";
import mitt from "mitt";
import VideoIcon from "../../images/Video_Inactive.svg";
import VideoActiveIcon from "../../images/Video_Active.svg";

import { getSlideDetailsById, updatSlideData } from "../../services/apis";

let funcMediaTab = "";
export const emitter = mitt();
 
export const MediaTabFunction = (setState) => {
  funcMediaTab = setState;
};

function setMediaTab() {
  funcMediaTab(true);
}
const hideOtherComponents = () => {
  const ImageBlock = document.querySelector(".gjs-blocks-no-cat .gjs-blocks-c")
    .children[2];
  ImageBlock.getElementsByClassName("gjs-block__media")[0].firstChild.src =
    ImageIconDefault;
  ImageBlock.classList.remove("active-block");
  const showStructure = document.querySelector(
    ".gjs-blocks-no-cat .gjs-blocks-c"
  ).firstChild;
  showStructure.style.cursor = "pointer";
  showStructure.getElementsByClassName("gjs-block__media")[0].firstChild.src =
    StructureActive;
  showStructure.classList.add("active-block");
  // showStructure.getElementsByTagName('img')[0].src = "../images/Structure-active.svg"
  const hideStructureBlockgjs = document.querySelector(
    ".gjs-block-categories .gjs-blocks-c"
  );
  hideStructureBlockgjs.classList.remove("d-none");
  const showBackbutton = document.querySelector("#test");
  if (showBackbutton) {
    //showBackbutton.classList.add("d-none");
  }

  const hideOtherblock = document.querySelector(".gjs-blocks-no-cat");
  const structureID = document.querySelector("#structure");
  // hideOtherblock.classList.add("d-none");
  const showStracture = document.querySelector(
    ".gjs-block-categories"
  ).firstChild;
  const showFormsBlock = document.querySelector(
    ".gjs-block-categories"
  ).lastElementChild;
  showFormsBlock.classList.add("d-none");
  showStracture.classList.remove("d-none");
  const hideStructure = document.querySelector(
    ".gjs-blocks-no-cat .gjs-blocks-c"
  ).lastElementChild;
  hideStructure.getElementsByClassName("gjs-block__media")[0].lastChild.src =
    InActiveFormIcon;
  hideStructure.classList.add("forms-inActive-block");
  hideStructure.classList.remove("forms-active-block", "active-block");
};

const hideStractureComponents = () => {
  const hideStracture = document.querySelector(
    ".gjs-block-categories"
  ).firstChild;
  const showFormsBlock = document.querySelector(
    ".gjs-block-categories"
  ).lastElementChild;
  hideStracture.classList.add("d-none");
  showFormsBlock.classList.remove("d-none");

  const activeFormsBlocks = document.querySelector(
    ".gjs-blocks-no-cat .gjs-blocks-c"
  ).lastElementChild;
  const inActiveFormsBlocks = document.querySelector(
    ".gjs-blocks-no-cat .gjs-blocks-c"
  ).firstChild;
  activeFormsBlocks.getElementsByClassName(
    "gjs-block__media"
  )[0].lastChild.src = ActiveFormIcon;
  inActiveFormsBlocks.getElementsByClassName(
    "gjs-block__media"
  )[0].lastChild.src = InActiveStructureIcon;
  inActiveFormsBlocks.classList.remove("active-block");
  activeFormsBlocks.classList.add("forms-active-block", "active-block");
  activeFormsBlocks.classList.remove("forms-inActive-block");
  showFormsBlock.classList.remove("d-none");
  const ImageBlock = document.querySelector(".gjs-blocks-no-cat .gjs-blocks-c")
    .children[2];
  ImageBlock.getElementsByClassName("gjs-block__media")[0].firstChild.src =
    ImageIconDefault;
  ImageBlock.classList.remove("active-block");
  const showBackbutton = document.querySelector("#test");
  if (showBackbutton) {
    showBackbutton.classList.add("d-none");
  }
};
const switchBlockCompoents = (blockComp) => {
  const imgLeaveObj = {
    structure: Structure,
    tabs: TabIcon,
    link: ButtonDefault,
    table: TableIcon,
    image: ImageIconDefault,
    video: VideoIcon,
    text: TextIcon,
    forms: InActiveFormIcon,
    extra: InActiveExtraBlock,
    popup: InActivePopUpBlockIcon,
  };
  const activeObj = {
    structure: StructureActive,
    text: BlockTextActive,
    forms: ActiveFormIcon,
    extra: ActiveExtraBlock,
    image: ActiveImageBlock,
    video: VideoActiveIcon,
    table: ActiveTableBlock,
    link: ActiveLinkBlock,
    popup: ActivePopUpBlockIcon,
  };
  const childNodesBlock = document?.querySelector(
    ".gjs-blocks-no-cat .gjs-blocks-c"
  )?.childNodes;
  childNodesBlock.forEach((blockElem) => {
    const imgTag =
      blockElem.getElementsByClassName("gjs-block__media")[0].firstChild;
    const structureBlock = document.querySelector(
      ".gjs-block-categories"
    ).firstChild;
    const formBlock = document.querySelector(".gjs-block-categories")
      .childNodes[1];
    const textBlock = document.querySelector(
      ".gjs-block-categories"
    ).lastElementChild;
    const extraBlock = document.querySelector(
      ".gjs-block-categories"
    ).lastElementChild;
    const extra = extraBlock.lastElementChild;
   // console.log(extra, 'eee')
    const extraFirstElement = extra.childNodes[0];
    const extraSecondElement = extra.childNodes[1];
    const extraThirdElement = extra.childNodes[2];
    const extraFourthElement = extra.childNodes[3];
    const extraFifthElement = extra.childNodes[4];
    const extraSixthElement = extra.childNodes[5];
    const extraSeventhElement = extra.childNodes[6];
    const extraEighthElement = extra.childNodes[7];
    const extraNinethElement = extra.childNodes[8];
    const extraTenthElement = extra.childNodes[9];
    const extraElevanthElement  = extra.childNodes[10];
    const extraTwelethElement  = extra.childNodes[11];
    const extraThirteenthElement  = extra.childNodes[12];
    const showBackbutton = document.querySelector("#test");

    if (blockComp.id === "forms") {
      //setState(false);
      structureBlock?.classList?.add("d-none");
      formBlock?.classList.remove("d-none");
      formBlock?.classList.add("d-block");
      textBlock?.classList.add("d-none");
      textBlock?.classList.remove("d-block");

      if (showBackbutton) {
        showBackbutton.classList.add("d-none");
      }
    }
    if (blockComp.id === "structure") {
      formBlock?.classList.add("d-none");
      formBlock?.classList.remove("d-block");
      structureBlock?.classList.remove("d-none");
      structureBlock?.classList.add("d-block");
      textBlock?.classList.add("d-none");
      textBlock?.classList.remove("d-block");
      structureBlock?.lastElementChild?.classList.remove("d-none");
      structureBlock?.lastElementChild?.classList.add("d-block");
      structureBlock?.lastElementChild?.classList?.add("d-flex");
      //Extra BLock starts here
      extraFirstElement.classList.add("d-block");
      extraSecondElement.classList.add("d-block");
      extraThirdElement.classList.add("d-block");
      extraFirstElement.classList.remove("d-none");
      extraSecondElement.classList.remove("d-none");
      extraThirdElement.classList.remove("d-none");
      extraFourthElement.classList.add("d-none");
      extraFifthElement.classList.add("d-none");
      //Extra BLock ends above
      // hide image block
      if (showBackbutton) {
        showBackbutton.classList.add("d-none");
      }
    }
    if (blockComp.id === "text") {
      formBlock?.classList.add("d-none");
      formBlock?.classList.remove("d-block");
      structureBlock?.classList.remove("d-block");
      structureBlock?.classList.add("d-none");
      textBlock?.classList.add("d-block");

      textBlock?.classList.remove("d-none");
      extraFirstElement.classList.add("d-block");
      extraSecondElement.classList.add("d-block");
      extraThirdElement.classList.add("d-block");
      extraFirstElement.classList.remove("d-none");
      extraSecondElement.classList.remove("d-none");
      extraThirdElement.classList.remove("d-none");
      extraFourthElement.classList.add("d-none");
      extraFifthElement.classList.add("d-none");
      extraSixthElement.classList.add("d-none");
      extraSixthElement.classList.remove("d-block");
      extraSeventhElement.classList.add("d-none");
      extraSeventhElement.classList.remove("d-block");
      extraEighthElement?.classList?.add("d-none");
      extraEighthElement?.classList?.remove("d-block");
      extraNinethElement?.classList?.add("d-none");
      extraNinethElement?.classList?.remove("d-block");
      extraTenthElement?.classList?.add("d-none");
      extraTenthElement?.classList?.remove("d-block");
      if (showBackbutton) {
        showBackbutton.classList.add("d-none");
      }
    }
    if (blockComp.id === "Images") {
      formBlock?.classList.add("d-none");
      formBlock?.classList.remove("d-block");
      structureBlock?.classList.remove("d-block");
      structureBlock?.classList.add("d-none");
      textBlock?.classList?.add("d-block");
      textBlock?.classList?.remove("d-none");
      extraFirstElement?.classList.add("d-none");
      extraFirstElement?.classList.remove("d-block");
      extraSecondElement?.classList.add("d-none");
      extraSecondElement?.classList.remove("d-block");
      extraThirdElement?.classList.add("d-none");
      extraThirdElement?.classList.remove("d-block");
      extraFourthElement.classList.add("d-none");
      extraFifthElement.classList.add("d-none");
      extraFifthElement?.classList?.remove("d-block");
      extraSixthElement?.classList?.add("d-none");
      extraSixthElement?.classList?.remove("d-block");
      extraSeventhElement?.classList?.add("d-block");
      extraSeventhElement?.classList?.remove("d-none");
      extraEighthElement?.classList?.add("d-none");
      extraEighthElement?.classList?.remove("d-block");
      extraNinethElement?.classList?.add("d-none");
      extraNinethElement?.classList?.remove("d-block");
      extraTenthElement?.classList?.add("d-none");
      extraTenthElement?.classList?.remove("d-block");
      const ImageBlock = document.querySelector(".gjs-blocks-no-cat .gjs-blocks-c").children[2];
      ImageBlock.getElementsByClassName("gjs-block__media")[0].firstChild.src = ActiveImageBlock;
      ImageBlock?.classList?.add("active-block");
      // ImageBlock.classList.add("remmove");
      // hide image block
      if (showBackbutton) {
        showBackbutton.classList.add("d-none");
      } 
    }
    if (blockComp.id === "video") {
      console.log('ghjk');
      formBlock?.classList.add("d-none");
      formBlock?.classList.remove("d-block");
      structureBlock?.classList.remove("d-block");
      structureBlock?.classList.add("d-none");
      textBlock?.classList?.add("d-block");
      textBlock?.classList?.remove("d-none");
      extraFirstElement?.classList.add("d-none");
      extraFirstElement?.classList.remove("d-block");
      extraSecondElement?.classList.add("d-none");
      extraSecondElement?.classList.remove("d-block");
      extraThirdElement?.classList.add("d-none");
      extraThirdElement?.classList.remove("d-block");
      extraFourthElement.classList.add("d-none");
      extraFourthElement.classList.remove("d-block");
      extraFifthElement.classList.add("d-none");
      extraFifthElement?.classList?.remove("d-block");
      extraSixthElement?.classList?.add("d-none");
      extraSixthElement?.classList?.remove("d-block");
      extraSeventhElement?.classList?.add("d-none");
      extraSeventhElement?.classList?.remove("d-block");
      extraEighthElement?.classList?.add("d-block");
      extraEighthElement?.classList?.remove("d-none");
      extraNinethElement?.classList?.add("d-none");
      extraNinethElement?.classList?.remove("d-block");
      extraTenthElement?.classList?.add("d-none");
      extraTenthElement?.classList?.remove("d-block");
      const ImageBlock = document.querySelector(".gjs-blocks-no-cat .gjs-blocks-c").children[3];
      ImageBlock.getElementsByClassName("gjs-block__media")[0].firstChild.src = VideoActiveIcon;
      ImageBlock?.classList?.add("active-block");
       // ImageBlock.classList.add("remmove");
       // hide image block
      if (showBackbutton) {
        showBackbutton.classList.add("d-none");
      } 
      //  showImageComponentFunc(false);
      //  showVideoComponentFunc(true);
     }
    if (blockComp.id === "table") {
      formBlock?.classList.add("d-none");
      formBlock?.classList.remove("d-block");
      structureBlock?.classList.remove("d-block");
      structureBlock?.classList.add("d-none");
      extraSixthElement.classList.add("d-none");
      extraSixthElement.classList.remove("d-block");
      extraSeventhElement.classList.add("d-none");
      extraSeventhElement.classList.remove("d-block");
      textBlock?.classList?.add("d-block");
      textBlock?.classList?.remove("d-none");
      extraFirstElement?.classList.add("d-none");
      extraFirstElement?.classList.remove("d-block");
      extraSecondElement?.classList.add("d-none");
      extraSecondElement?.classList.remove("d-block");
      extraThirdElement?.classList.add("d-none");
      extraThirdElement?.classList?.remove("d-block");
      extraFourthElement?.classList?.add("d-none");
      extraFifthElement?.classList?.add("d-none");
      extraEighthElement?.classList?.add("d-none");
      extraEighthElement?.classList?.remove("d-block");
      extraNinethElement?.classList?.add("d-block");
      extraNinethElement?.classList?.remove("d-none");
      extraTenthElement?.classList?.add("d-block");
      extraTenthElement?.classList?.remove("d-none");
      // hide image block
      if (showBackbutton) {
        showBackbutton.classList.add("d-none");
      } 
    }
    if (blockComp.id === "link") {
      //setState(false);
      formBlock?.classList?.add("d-none");
      formBlock?.classList?.remove("d-block");
      structureBlock?.classList?.remove("d-block");
      structureBlock?.classList?.add("d-none");
      extraFirstElement?.classList?.add("d-none");
      extraSecondElement?.classList?.add("d-none");
      extraThirdElement?.classList?.add("d-none");
      extraFourthElement?.classList?.add("d-none");
      extraFourthElement?.classList?.remove("horizontal-block");
      extraFifthElement?.classList?.add("link-block");
      extraFifthElement?.classList?.remove("d-none");
      extraBlock?.classList?.remove("d-none");
      extraSixthElement?.classList?.add("d-block");
      extraSixthElement?.classList?.remove("d-none");
      extraSeventhElement?.classList?.add("d-none");
      extraSeventhElement?.classList?.remove("d-block");
      extraEighthElement?.classList?.add("d-none");
      extraEighthElement?.classList?.remove("d-block");
      extraNinethElement?.classList?.add("d-none");
      extraNinethElement?.classList?.remove("d-block");
      extraTenthElement?.classList?.add("d-none");
      extraTenthElement?.classList?.remove("d-block");
      if (showBackbutton) {
        showBackbutton.classList.add("d-none");
      }
    }
    //Extra starts here
    if (blockComp.id === "extra") {
      //setState(false);
      formBlock?.classList.add("d-none");
      formBlock?.classList.remove("d-block");
      structureBlock?.classList.remove("d-block");
      structureBlock?.classList.add("d-none");
      extraFirstElement.classList.add("d-none");
      extraSecondElement.classList.add("d-none");
      extraThirdElement.classList.add("d-none");
      extraFourthElement.classList.add("horizontal-block");
      extraFourthElement.classList.remove("d-none");
      extraFifthElement.classList.add("d-none");
      extraFifthElement.classList.remove("link-block");
      extraBlock.classList.remove("d-none");
      extraSixthElement.classList.add("d-none");
      extraSixthElement.classList.remove("d-block");
      extraSeventhElement.classList.add("d-none");
      extraSeventhElement.classList.remove("d-block");
      extraEighthElement.classList.add("d-none");
      extraEighthElement.classList.remove("d-block");
      extraNinethElement.classList.add("d-none");
      extraNinethElement.classList.remove("d-block");
      extraTenthElement?.classList?.add("d-none");
      extraTenthElement?.classList?.remove("d-block");
      if (showBackbutton) {
        showBackbutton.classList.add("d-none");
      }
      // formBlock?.classList.add("d-none");
      // formBlock?.classList.remove("d-block");
      // structureBlock?.classList.remove("d-block");
      // structureBlock?.classList.add("d-none");
      // extraFirstElement.classList.add("d-none");
      // extraSecondElement.classList.add("d-none");
      // extraThirdElement.classList.add("d-none");
      // extraFourthElement.classList.remove("d-none");
      // extraFourthElement.classList.add("horizontal-block");
      // extraFifthElement.classList.remove("d-none");
      // extraFifthElement.classList.add("link-block");
      // extraBlock.classList.remove("d-none");
      if (showBackbutton) {
        showBackbutton.classList.add("d-none");
      }
    }
    //Extra ends above
    
    if (blockComp.id === "popup") {
      // setState(false);
      formBlock?.classList.add("d-none");
      formBlock?.classList.remove("d-block");
      structureBlock?.classList.remove("d-block");
      structureBlock?.classList.remove("active-block");
      structureBlock?.classList.add("d-none");
      extraFirstElement.classList.add("d-none");
      extraSecondElement.classList.add("d-none");
      extraThirdElement.classList.add("d-none");
      extraFourthElement.classList.add("d-none");
      extraFourthElement.classList.remove("horizontal-block");
      extraFifthElement.classList.add("d-none");
      extraFifthElement.classList.remove("link-block");
      extraBlock.classList.remove("d-none");
      extraSixthElement.classList.add("d-none");
      extraSixthElement.classList.remove("d-block");
      extraSeventhElement.classList.add("d-none");
      extraSeventhElement.classList.remove("d-block");
      extraEighthElement.classList.add("d-none");
      extraEighthElement.classList.remove("d-block");
      extraNinethElement.classList.add("d-none");
      extraNinethElement.classList.remove("d-block");
      extraTenthElement?.classList?.add("d-none");
      extraTenthElement?.classList?.remove("d-block");
      extraElevanthElement?.classList?.add("d-block");
      extraElevanthElement?.classList?.remove("d-none");
      extraTwelethElement?.classList?.add("d-block");
      extraTwelethElement?.classList?.remove("d-none");
      extraThirteenthElement?.classList?.add("d-block");
      extraThirteenthElement?.classList?.remove("d-none");
      if (showBackbutton) {
        showBackbutton.classList.add("d-none");
      }
      if (showBackbutton) {
        showBackbutton.classList.add("d-none");
      }
    }
    else {      
      console.log('1111111111')
      extraElevanthElement?.classList?.add("d-none");
      extraElevanthElement?.classList?.remove("d-block");
      extraTwelethElement?.classList?.add("d-none");
      extraTwelethElement?.classList?.remove("d-block");
      extraThirteenthElement?.classList?.add("d-none");
      extraThirteenthElement?.classList?.remove("d-block");
    }
    if (blockComp.id === imgTag.alt) {
      console.log(blockComp.id, '222222222', imgTag)
      imgTag.src = activeObj[imgTag.alt];
      blockElem.classList.add("active-block");
    } else {
      if (imgLeaveObj.hasOwnProperty(imgTag.alt)) {
        blockElem.getElementsByClassName("gjs-block__media")[0].firstChild.src =
          imgLeaveObj[imgTag.alt];
        if (blockElem.classList.contains("active-block")) {
          blockElem.classList.remove("active-block");
      console.log('33333333')

        }
      }
    }
  });
};
export const defaultBlocks = {
  appendTo: "#blocks",
  // custom: true,
  // open: false,
  blocks: [
    {
      id: "structure",
      media: `<img src="${StructureActive}" alt="structure" />`,
      attributes: { class: 'custom-structure', 'data-title': 'Structure' },
      // Use `image` component
      content: {
        type: "structure",
      },
      activate: true,
      onClick: switchBlockCompoents,
    },
    {
      id: "text",
      media: `<img src="${TextIcon}" alt="text" class="text-icon" onclick="this.src="../.../.."/>`,
      attributes: { class: 'custom-text', 'data-title': 'Text' },
        activate: true,
      /*  content: {
         type: "text",
         content: "Insert your text here",
         style: {
           padding: "10px",
           // fontSize: "12px",
           // fontFamily: "Calibri",
           "font-size": "12px",
           "font-family": "'Calibri', sans-serif",
         },
         activeOnRender: 1,
       }, */
      onClick: switchBlockCompoents,
    },
    {
      id: "Images",

      // label: "Images",

      media: `<img src="${ImageIcon}" alt="image" > </img>`,
      attributes: { class: 'custom-images', 'data-title': 'Image' },
      // content: {
      //   type: "image",
      // },
      // content: {
      //   type: "image",

      //   attributes: { alt: "image" },
      //   unstylable: [
      //     "display",
      //     "font-family",
      //     "font-size",
      //     "font-weight",
      //     "letter-spacing",
      //     "color",
      //     "line-height",
      //     "text-align",
      //     "text-decoration",
      //     "text-shadow",
      //     "background",
      //     "background-image",
      //     "background-repeat",
      //     "background-position",
      //     "background-size",
      //     "background-attachment",
      //     "modular_content",
      //   ],
      // },

      activate: true,
      onClick: switchBlockCompoents,
      script: function() {
            this.onclick = () => alert('Image clicked!');
          }
    },
    {
      id: "video",
      media: `<img src="${VideoIcon}" alt="video" />`,
      attributes: { class: 'custom-video', 'data-title': 'Video' },
      activate: true,
      content: { type: "video" },
      onClick: switchBlockCompoents
    },
    // {
    //   id: "Video",
    //   media: `<img src="${VideoIcon}" alt="video" draggable="true" /> `,
    //   //activate: true,
    //   // onClick: setMediaTab,
    //   content: {
    //     type: "video",
    //     src: "",
    //     unstylable: [
    //       "font-family",
    //       "font-size",
    //       "font-weight",
    //       "letter-spacing",
    //       "color",
    //       "line-height",
    //       "text-align",
    //       "text-decoration",
    //       "text-shadow",
    //       "transform",
    //       "transition",
    //       "perspective",
    //       "modular_content",
    //     ],
    //     style: {
    //       width: "300px",
    //     },
    //   },
    //   //  unstylable: ["transform", "transition", "perspective"],
    // },
    {
      id: "table",
      media: `<img src="${TableIcon}" alt="table" />`,
      attributes: { class: 'custom-table', 'data-title': 'Table / Tabs' },
      content: { type: "table" },
      activate: true,
      onClick: switchBlockCompoents
    },
    {
      id: "link",
      media: `<img src="${ButtonDefault}" alt="link" ></img>`,
      attributes: { class: 'custom-link', 'data-title': 'Button / Link Block' },
      //content: { type: "link" },
      activate: true,
      onClick: switchBlockCompoents,
      // content: {
      //   type: "link",
      //   content: "Click Me !",

      //   attributes: {
      //     // href: "https://www.google.com",
      //     alt: "link",
      //     contenteditable: false,
      //   },
      //   traits: [
      //     {
      //       type: "text",
      //       name: "Title",
      //       label: "Title",
      //       placeholder: "Enter title",
      //     },
      //     {
      //       type: "href",
      //       name: "href",
      //       label: "URL",
      //       changeProp: true,
      //     },
      //     {
      //       type: "select",
      //       name: "target",
      //       label: "Target",
      //       default: "_self",
      //       changeProp: true,
      //       options: [
      //         // Here the key is the `id` of the option
      //         { id: "_self", label: "This window", value: "_self" },
      //         { id: "_blank", label: "New window", value: "_blank" },
      //       ],
      //     },
      //   ],

      //   unstylable: ["transform", "transition", "perspective"],
      //   style: {
      //     // width: "54px",
      //     // height: "32px",
      //     padding: "8px 28px",
      //     //border: "solid 1px #203662",
      //     "background-color": "#203662",
      //     "font-size": "12px",
      //     "font-weight": "bold",
      //     "letter-spacing": "0.1px",
      //     "text-align": "center",
      //     color: "#fff",
      //     cursor: "pointer",
      //     display: "inline-block",
      //     "text-decoration": "none",
      //     "font-family": "Nunito Sans",
      //     outline: "none",
      //   },
      // },
    },
    // {
    //   id: "form",
    //   label: "Forms",
    //   media: `<img src="${Dropdown}" alt="dropdown" />`,
    //   content: { type: "form" },
    //   activate: true,
    // },
    // {
    //   id: "select",
    //   label: "Dropdown",
    //   media: `<img src="${Dropdown}" alt="dropdown" />`,
    //   content: { type: "select", options: ["hello", "hi"] },
    //   activate: true,
    // },

    // {
    //   id: "tabs",
    //   media: `<img src="${TabIcon}" alt="tabs" />`,
    //   content: {
    //     type: "tabs",
    //     unstylable: ["transform", "transition", "perspective"],
    //   },
    //   activate: true,
    // },
    {
      id: "forms",
      // label: "Form",
      media: `<img src="${InActiveFormIcon}" alt="forms" className="forms-image" />`,
      attributes: { class: 'custom-forms', 'data-title': 'Forms' },
      content: { type: "form" },
      activate: true,
      onClick: switchBlockCompoents,
      open: false,
    },
    {
      id: "extra",
      // label: "Extra(s)",
      media: `<img src="${InActiveExtraBlock}" alt="extra" className="extra-image" />`,
      attributes: { class: 'custom-extra', 'data-title': 'Other tools' },
      content: { type: "extra" },
      activate: true,
      onClick: switchBlockCompoents,
    },    
    {
      id: "popup",
      // label: "Extra(s)",
      media: `<img src="${InActivePopUpBlockIcon}" alt="popup" className="popup-image" />`,
      attributes: { class: 'custom-popup', 'data-title': 'Pop up' },
      content: { type: "popup" },
      activate: true,
      onClick: switchBlockCompoents,
    },
    // {
    //   id: "scroll",
    //   label: "Scroll",
    //   media: `<img src="${Scroll}" alt="scroll" />`,
    //   content: { type: "scroll" },
    //   activate: true,
    // },
  ],
};

export const styleManager = {
  appendTo: "#stylesMangerBlock",
  custom: true,
  sectors: [
  /* {
      name: "Common Content",
      properties: [
        {
          type: "Common-Html-Content",
          property: "common_content",
          label: "Common Content",
          default: false,
          toRequire: 0,
          commonHtml:false
        },
      ],
    }, */ 
    {
      name: "Modular Content",
      properties: [
        {
          type: "Custom-Modular-Content",
          property: "modular_content",
          label: "Modular Content",
          default: "false",
          toRequire: 0,
          approve: false,
          reference: false,
          // Additional props
          /* options: [
            { id: 'approve', label: 'Approved' },
            { id: 'reference', label: 'Reference' },
            { id: 'none', label: 'None', toRequire: 1 },
          ],
          onChange: function (value) {
            console.log(value);
          } */
        },
      ],
    },
    {
      name: "General",
      buildProps: [
        "float",
        "display",
        "position",
        "top",
        "right",
        "left",
        "bottom",
        "z-index",
      ],
      properties: [
        {
          name: "Alignment",
          property: "float",
          type: "radio",
          defaults: "none",
          list: [
            { value: "none", className: "fa fa-times" },
            { value: "left", className: "fa fa-align-left" },
            { value: "right", className: "fa fa-align-right" },
          ],
        },
        { property: "position", type: "select" },
        {
          property: "z-index",
          type: "number",
          name: "z-index",
          min: -100,
        },
      ],
    },
    {
      name: "Dimension",
      open: false,
      buildProps: [
        "width",
        "flex-width",
        "height",
        "max-width",
        "min-height",
        "margin",
        "padding",
        //"color",
      ],
      properties: [
        {
          id: "flex-width",
          type: "integer",
          name: "Width",
          units: ["px", "%"],
          property: "flex-basis",
          toRequire: 1,
        },
        // { properties: [{ name: "Font color", property: "color" }] },
        {
          property: "margin",
          properties: [
            { name: "Top", property: "margin-top" },
            { name: "Right", property: "margin-right" },
            { name: "Bottom", property: "margin-bottom" },
            { name: "Left", property: "margin-left" },
          ],
        },
        {
          property: "padding",
          properties: [
            { name: "Top", property: "padding-top" },
            { name: "Right", property: "padding-right" },
            { name: "Bottom", property: "padding-bottom" },
            { name: "Left", property: "padding-left" },
          ],
        },
      ],
    },
    {
      name: "Typography",
      open: false,
      buildProps: [
        "font-family",
        "font-size",
        "font-style",
        "font-weight",
        "letter-spacing",
        "color",
        "line-height",
        "text-align",
        "text-decoration",
        "text-shadow",
      ],
      properties: [
        {
          property: "font-family",
          name: "Font family",
          // type: "select"
          //default: "'Calibri', sans-serif",
          default: 'inherit'
        },
        { name: "Weight", property: "font-weight" },
        { name: "Font color", property: "color", default: "" },

        {
          property: "font-size",
          type: "number",
          default: "12",
          name: "Font size",
          units: ["px", "%", "em", "rem", "vh", "vw"],
          min: 0,
        },
        {
          property: "font-style",
          type:"select",
          default: "normal",
          name: "Font Style",
          list: [
            { value: "normal", name: "normal" },
            { value: "italic", name: "italic" },
            { value: "oblique", name: "oblique" },
            { value: "initial", name: "initial" },
            { value: "inherit", name: "inherit" }
          ],
        },
        {
          property: "letter-spacing",
          type: "number",
          default: "0",
          name: "Letter spacing",
          units: ["px", "%", "em", "rem", "vh", "vw"],
          min: -100,
        },
        {
          property: "text-align",
          type: "radio",
          defaults: "left",
          list: [
            { value: "left", name: "Left", className: "fa fa-align-left" },
            {
              value: "center",
              name: "Center",
              className: "fa fa-align-center",
            },
            { value: "right", name: "Right", className: "fa fa-align-right" },
            {
              value: "justify",
              name: "Justify",
              className: "fa fa-align-justify",
            },
          ],
        },
        {
          property: "text-decoration",
          type: "radio",
          defaults: "none",
          list: [
            { value: "none", name: "None", className: "fa fa-times" },
            {
              value: "underline",
              name: "underline",
              className: "fa fa-underline",
            },
            {
              value: "line-through",
              name: "Line-through",
              className: "fa fa-strikethrough",
            },
          ],
        },
        {
          property: "text-shadow",
          properties: [
            { name: "X position", property: "text-shadow-h" },
            { name: "Y position", property: "text-shadow-v" },
            { name: "Blur", property: "text-shadow-blur" },
            { name: "Color", property: "text-shadow-color" },
          ],
        },
        {
          property: "text-indent",
          type: "number",
         
          name: "Text-Indent",
          units: ["px", "%", "em", "rem", "vh", "vw"],
          min: -100,
        },
      ],
    },
    {
      name: "Decorations",
      open: false,
      buildProps: [
        "opacity",
        "border-radius",
        "border",
        "box-shadow",
        "background",
      ],
      properties: [
        {
          property: "background-color",
          default: "none",
          type: "color",
          name: "background-color",
        },
      ],
    },
    {
      name: "Animations",
      open: false,
      buildProps: ["transition", "perspective", "transform"],
    },
    // {
    //   name: "Settings",
    //   buildProps: ["src", "provider"],
    //   properties: [
    //     {
    //       name: "Source",
    //       property: "src",
    //       type: "text",
    //       defaults: "eg. ./media/video.mp4",

    //   //       // list: [{ value: "src", className: "fa fa-times" }],
    //   //     },
    //   //     {
    //   //       name: "Provider",
    //   //       property: "provider",
    //   //       type: "select",
    //   //       defaults: "html5",
    //   //       list: [
    //   //         { value: "html5", name: "HTML5" },
    //   //         { value: "youtube", name: "Youtube" },
    //   //         { value: "vimeo", name: "Vimeo" },
    //   //       ],
    //   //       // list: [{ value: "src", className: "fa fa-times" }],
    //   //     },
    //   //     {
    //   //       name: "Poster",
    //   //       property: "poster",
    //   //       type: "text",
    //   //       defaults: "eg. ./media/image",

    //   //       // list: [{ value: "src", className: "fa fa-times" }],
    //   //     },
    //   //   ],
    //   // },
    //   {
    //     name: "Extra",
    //     open: false,
    //     buildProps: ["transition", "perspective", "transform"],
    //     properties: [
    //       {
    //         property: "transition",
    //         properties: [
    //           { name: "Property", property: "transition-property" },
    //           { name: "Duration", property: "transition-duration" },
    //           { name: "Easing", property: "transition-timing-function" },
    //         ],
    //       },
    //       {
    //         property: "transform",
    //         properties: [
    //           { name: "Rotate X", property: "transform-rotate-x" },
    //           { name: "Rotate Y", property: "transform-rotate-y" },
    //           { name: "Rotate Z", property: "transform-rotate-z" },
    //           { name: "Scale X", property: "transform-scale-x" },
    //           { name: "Scale Y", property: "transform-scale-y" },
    //           { name: "Scale Z", property: "transform-scale-z" },
    //         ],
    //       },
    //     ],
    //   },
    //   {
    //     name: "Flex",
    //     open: false,
    //     properties: [
    //       {
    //         name: "Flex Container",
    //         property: "display",
    //         type: "select",
    //         defaults: "block",
    //         list: [
    //           { value: "block", name: "Disable" },
    //           { value: "flex", name: "Enable" },
    //         ],
    //       },
    //       {
    //         name: "Flex Parent",
    //         property: "label-parent-flex",
    //         type: "integer",
    //       },
    //       {
    //         name: "Direction",
    //         property: "flex-direction",
    //         type: "radio",
    //         defaults: "row",
    //         list: [
    //           {
    //             value: "row",
    //             name: "Row",
    //             className: "icons-flex icon-dir-row",
    //             title: "Row",
    //           },
    //           {
    //             value: "row-reverse",
    //             name: "Row reverse",
    //             className: "icons-flex icon-dir-row-rev",
    //             title: "Row reverse",
    //           },
    //           {
    //             value: "column",
    //             name: "Column",
    //             title: "Column",
    //             className: "icons-flex icon-dir-col",
    //           },
    //           {
    //             value: "column-reverse",
    //             name: "Column reverse",
    //             title: "Column reverse",
    //             className: "icons-flex icon-dir-col-rev",
    //           },
    //         ],
    //       },
    //       {
    //         name: "Justify",
    //         property: "justify-content",
    //         type: "radio",
    //         defaults: "flex-start",
    //         list: [
    //           {
    //             value: "flex-start",
    //             className: "icons-flex icon-just-start",
    //             title: "Start",
    //           },
    //           {
    //             value: "flex-end",
    //             title: "End",
    //             className: "icons-flex icon-just-end",
    //           },
    //           {
    //             value: "space-between",
    //             title: "Space between",
    //             className: "icons-flex icon-just-sp-bet",
    //           },
    //           {
    //             value: "space-around",
    //             title: "Space around",
    //             className: "icons-flex icon-just-sp-ar",
    //           },
    //           {
    //             value: "center",
    //             title: "Center",
    //             className: "icons-flex icon-just-sp-cent",
    //           },
    //         ],
    //       },
    //       {
    //         name: "Align",
    //         property: "align-items",
    //         type: "radio",
    //         defaults: "center",
    //         list: [
    //           {
    //             value: "flex-start",
    //             title: "Start",
    //             className: "icons-flex icon-al-start",
    //           },
    //           {
    //             value: "flex-end",
    //             title: "End",
    //             className: "icons-flex icon-al-end",
    //           },
    //           {
    //             value: "stretch",
    //             title: "Stretch",
    //             className: "icons-flex icon-al-str",
    //           },
    //           {
    //             value: "center",
    //             title: "Center",
    //             className: "icons-flex icon-al-center",
    //           },
    //         ],
    //       },
    //       {
    //         name: "Flex Children",
    //         property: "label-parent-flex",
    //         type: "integer",
    //       },
    //       {
    //         name: "Order",
    //         property: "order",
    //         type: "integer",
    //         defaults: 0,
    //         min: 0,
    //       },
    //       {
    //         name: "Flex",
    //         property: "flex",
    //         type: "composite",
    //         properties: [
    //           {
    //             name: "Grow",
    //             property: "flex-grow",
    //             type: "integer",
    //             defaults: 0,
    //             min: 0,
    //           },
    //           {
    //             name: "Shrink",
    //             property: "flex-shrink",
    //             type: "integer",
    //             defaults: 0,
    //             min: 0,
    //           },
    //           {
    //             name: "Basis",
    //             property: "flex-basis",
    //             type: "integer",
    //             units: ["px", "%", ""],
    //             unit: "",
    //             defaults: "auto",
    //           },
    //         ],
    //       },
    //       {
    //         name: "Align",
    //         property: "align-self",
    //         type: "radio",
    //         defaults: "auto",
    //         list: [
    //           {
    //             value: "auto",
    //             name: "Auto",
    //           },
    //           {
    //             value: "flex-start",
    //             title: "Start",
    //             className: "icons-flex icon-al-start",
    //           },
    //           {
    //             value: "flex-end",
    //             title: "End",
    //             className: "icons-flex icon-al-end",
    //           },
    //           {
    //             value: "stretch",
    //             title: "Stretch",
    //             className: "icons-flex icon-al-str",
    //           },
    //           {
    //             value: "center",
    //             title: "Center",
    //             className: "icons-flex icon-al-center",
    //           },
    //         ],
    //       },
    //     ],
    //   },
    //
   // Flex 
    {
      name: "Flex",
      open: false,
      properties: [
        {
          name: "Flex Container",
          property: "display",
          type: "select",
          defaults: "block",
          list: [
            { value: "block", name: "Disable" },
            { value: "flex", name: "Enable" },
          ],
        },
        {
          name: "Flex Parent",
          property: "label-parent-flex",
          type: "integer",
        },
        {
          name: "Direction",
          property: "flex-direction",
          type: "radio",
          defaults: "row",
          list: [
            {
              value: "row",
              name: "Row",
              className: "icons-flex icon-dir-row",
              title: "Row",
            },
            {
              value: "row-reverse",
              name: "Row reverse",
             className: "icons-flex icon-dir-row-rev",
              title: "Row reverse",
            },
            {
              value: "column",
              name: "Column",
              title: "Column",
             className: "icons-flex icon-dir-col",
            },
            {
              value: "column-reverse",
              name: "Column reverse",
              title: "Column reverse",
              className: "icons-flex icon-dir-col-rev",
            },
          ],
        },
        {
          name: "Justify",
          property: "justify-content",
          type: "radio",
          defaults: "flex-start",
          list: [
            {
              value: "flex-start",
              className: "icons-flex icon-just-start",
              title: "Start",
            
              name:"Start"
            },
            {
              value: "flex-end",
              title: "End",
              name: "End",
              className: "icons-flex icon-just-end",
            },
            {
              value: "space-between",
              title: "Space between",
              name: "Space between",
              className: "icons-flex icon-just-sp-bet",
            },
            {
              value: "space-around",
              title: "Space around",
              name: "Space around",
              className: "icons-flex icon-just-sp-ar",
            },
            {
              value: "center",
              title: "Center",
              name:"Center",
              className: "icons-flex icon-just-sp-cent",
            },
          ],
        },
        {
          name: "Align",
          property: "align-items",
          type: "radio",
          defaults: "center",
          list: [
            {
              value: "flex-start",
              title: "Start",
              name:"start",
              className: "icons-flex icon-al-start",
            },
            {
              value: "flex-end",
              title: "End",
              name:"flex-end",
              className: "icons-flex icon-al-end",
            },
            {
              value: "stretch",
              title: "Stretch",
              name: "Stretch",
              className: "icons-flex icon-al-str",
            },
            {
              value: "center",
              title: "Center",
              name:"Center",
              className: "icons-flex icon-al-center",
            },
          ],
        },
        {
          name: "Flex Children",
          property: "label-parent-flex",
          type: "integer",
        },
        {
          name: "Order",
          property: "order",
          type: "integer",
          defaults: 0,
          min: 0,
        },
        {
          name: "Flex",
          property: "flex",
          type: "composite",
          properties: [
            {
              name: "Grow",
              property: "flex-grow",
              type: "integer",
              defaults: 0,
              min: 0,
            },
            {
              name: "Shrink",
              property: "flex-shrink",
              type: "integer",
              defaults: 0,
              min: 0,
            },
            {
              name: "Basis",
              property: "flex-basis",
              type: "integer",
              units: ["px", "%", ""],
              unit: "",
              defaults: "auto",
            },
          ],
        },
        {
          name: "Align",
          property: "align-self",
          type: "radio",
          defaults: "auto",
          list: [
            {
              value: "auto",
              name: "Auto",
            },
            {
              value: "flex-start",
              title: "Start",
              className: "icons-flex icon-al-start",
            },
            {
              value: "flex-end",
              title: "End",
              className: "icons-flex icon-al-end",
            },
            {
              value: "stretch",
              title: "Stretch",
              className: "icons-flex icon-al-str",
            },
            {
              value: "center",
              title: "Center",
              label:"Center",
              className: "icons-flex icon-al-center",
            },
          ],
        },
      ],
    },
  ],
};
export const blocks = [
  "column1",
  "column2",
  "column3",
  "column3-7",
  // "text",
  // "link",
  // //"image", //commented
  // // "video",
  // "table",
  // "tabs",
];

export const formblocks = ["form", "select"];

export const thirdPartyPlugins = [
  {
    "name": "Zoom",
    "url": "https://d3j7n5xv6swcxx.cloudfront.net/shared/scripts/zoom.js",
    "status": 1
  },
  {
    "name": "Veeva",
    "url": "https://d3j7n5xv6swcxx.cloudfront.net/shared/scripts/veeva-library.js",
    "status": 1
  },
  {
    "name": "Touchy",
    "url": "https://d3j7n5xv6swcxx.cloudfront.net/shared/scripts/touchy.js",
    "status": 1
  },
  {
    "name": "Underscore",
    "url": "https://d3j7n5xv6swcxx.cloudfront.net/shared/scripts/underscore-min.js",
    "status": 1
  },
  {
    "name": "iScroll",
    "url": "https://d3j7n5xv6swcxx.cloudfront.net/shared/scripts/iscroll-lite.js",
    "status": 1
  },
  {
    "name": "jQuery",
    "url": "https://d3j7n5xv6swcxx.cloudfront.net/shared/scripts/jquery-3.2.1.min.js",
    "status": 1
  },
  {
    "name": "Adaptive",
    "url": "https://d3j7n5xv6swcxx.cloudfront.net/shared/scripts/adaptive.js",
    "status": 1
  },
  {
    "name": "Fastclick",
    "url": "https://d3j7n5xv6swcxx.cloudfront.net/shared/scripts/fastclick.min.js",
    "status": 1
  },
  {
    "name": "Zepto",
    "url": "https://d3j7n5xv6swcxx.cloudfront.net/shared/scripts/zepto.min.js",
    "status": 1
  },
  {
    "name": "hammer",
    "url": "https://d3j7n5xv6swcxx.cloudfront.net/shared/scripts/hammer.min.js",
    "status": 1
  }
]


 export const getDeviceInfo = () => {
    const timezoneOffsetMinutes = new Date().getTimezoneOffset();
 
    const offsetHours = Math.floor(Math.abs(timezoneOffsetMinutes) / 60);
    const offsetMinutes = Math.abs(timezoneOffsetMinutes) % 60;
    const sign = timezoneOffsetMinutes <= 0 ? '+' : '-';
    const formattedTimezoneOffset = `UTC ${sign}${String(offsetHours).padStart(2, '0')}:${String(offsetMinutes).padStart(2, '0')}`;
 
    const userAgent = navigator.userAgent;
    const platform = navigator.platform;
    const is64Bit = userAgent.includes('Win64') || userAgent.includes('x64');
 
    const deviceInfo = {
        userAgent: userAgent,
        platform: platform,
        OS_architecture: is64Bit ? '64-bit' : '32-bit',
        language: navigator.language,
        screen: {
            width: window.screen.width,
            height: window.screen.height,
            innerWidth: window.innerWidth,
            innerHeight: window.innerHeight,
        },
        timezoneOffset: formattedTimezoneOffset,
    };
 
    return JSON.stringify(deviceInfo);
}; 

//   let getPagefromPagemanager = editor.Pages.get(slideid);
//   console.log(getPagefromPagemanager);
//   // if (getPagefromPagemanager !== undefined) {
//   //   editor.Pages.select(getPagefromPagemanager);
//   //   return;
//   // }
//   await getSlideDetailsById(slideid, (response, err, errorCode) => {
//     if (err) {
//     } else {
//       let obj = response.data;
//       let newobj = obj?.content;

//       let pageVal = {
//         id: obj?._id,
//         styles: obj?.content?.styles || "", // or a JSON of styles
//         component: obj?.content?.components || "<div></div>", // or a JSON of components
//       };
//       console.log(editor, "editor");
//       // editor.setStyle("");
//       const somePage = editor.editor.attributes.PageManager.get(pageVal.id);
//       editor.editor.attributes.PageManager.add(pageVal);

//       editor.editor.attributes.PageManager.select(somePage);
//       // let canvasEditor = editor.editor.getWrapper();
//       // canvasEditor.set("attributes", {
//       //   id: "testwhere",
//       // });
//       // editor.CssComposer.getRule("body")

//       // const regex = /body{(.*?)}/gms;
//       // console.log(regex, "test");
//       // let css = editor.getCss().replace(regex, "");
//       // editor.setStyle(css);
//       // editor.refresh();
//       // editor.setStyle("body{margin:0}");

//       if (currentSlideCopy !== undefined) {
//         if (index !== undefined) {
//           currentSlideCopy.master.children[index].slideid.name =
//             newobj?.slideName || obj?.name;
//           currentSlideCopy.master.children[index].slideid.key_message =
//             newobj?.keyMessage || obj?.key_message;
//         } else {
//           currentSlideCopy.slideid.name = newobj?.slideName || obj?.name;
//           currentSlideCopy.slideid.key_message =
//             newobj?.keyMessage || obj?.key_message;
//         }
//       }
//     }
//   });
// };

export const savePage = (editor, currentSlide) => {
  //editor.store();
  return;
  let ID =
    JSON.stringify(currentSlide?.child) === "{}"
      ? currentSlide?.master?.slideid?._id
      : currentSlide?.child?.slideid?._id;
  let payload = {
    content: {
      html: editor.getHtml(),
      css: editor.getCss({ avoidProtected: true }),
      components: editor.getComponents(),
      styles: editor.getStyle({ avoidProtected: true }),
      scripts:
        'const elements = document.querySelectorAll("[ccid]");\r\n    elements.forEach(function (element) {\r\n      if (element.hasAttribute("href")) {\r\n        element.removeAttribute("href")\r\n      }\r\n      var linkedId = element.getAttribute("ccid");\r\n      //binding onclick to popup comp\r\n      element.onclick = function (e) {\r\n        e.preventDefault();\r\n        var modal = document.querySelector(`[data-id = ${linkedId}]`);\r\n        modal.style.display = "block";\r\n        var close = document.querySelector(`[data-id = ${linkedId}] .close`);\r\n        close.onclick = function () {\r\n          e.preventDefault();\r\n          modal.style.display = "none";\r\n        };\r\n      };\r\n    });\r\n   /* $(document).on("click", "[href]", (evt) => {\r\n      evt.preventDefault();\r\n      let _link = evt.currentTarget.getAttribute("href");\r\n      // go to particular slide\r\n      com.veeva.clm.gotoSlide("slide2.zip", 12344556);\r\n    });*/\r\n\r\n    (function () {\r\n      function cida_swipedLeft() {\r\n        // go to prev slide by default\r\n        document.location = "veeva:prevSlide()";\r\n      }\r\n\r\n      function cida_swipedRight() {\r\n        // go to next slide by default\r\n        document.location = "veeva:nextSlide()";\r\n      }\r\n\r\n      function cida_swipedUp() { }\r\n\r\n      function cida_swipedDown() { }\r\n\r\n      window.addEventListener("swipeleft", cida_swipedLeft);\r\n      window.addEventListener("swiperight", cida_swipedRight);\r\n      window.addEventListener("swipeup", cida_swipedUp);\r\n      window.addEventListener("swipedown", cida_swipedDown);\r\n    })();\r\n\r\n    // Zepto\r\n    Zepto(function ($) {\r\n      // console.log("Ready to Zepto!");\r\n    });\r\n\r\n    // pinch zoom\r\n    /* var el = document.querySelector("div.pinch-zoom");\r\n    new PinchZoom.default(el, {}); */',
      thirdPartyPlugins: thirdPartyPlugins,
      slideName:
        JSON.stringify(currentSlide?.child) === "{}"
          ? currentSlide.master?.slideid?.name
          : currentSlide.child.slideid.name,
      keyMessage:
        JSON.stringify(currentSlide.child) === "{}"
          ? currentSlide?.master?.slideid?.key_message
          : currentSlide.child.slideid.key_message,
    },
  };
  updatSlideData(ID, payload, (response, err, errorCode) => {
    if (err) {
    } else {
    }
  });
};
export const script = `
// Close popup on .popup-close or [data-close-popup]
  document.querySelectorAll('.popup-close, [data-close-popup]').forEach(closeBtn => {
    closeBtn.addEventListener('click', (e) => {
      e.preventDefault();
      const popup = closeBtn.closest('.gjs-popup');
      if (popup) popup.style.display = 'none';
    });
  });
const elements = document.querySelectorAll("[ccid]");\r\n    elements.forEach(function (element) {\r\n      if (element.hasAttribute("href")) {\r\n        element.removeAttribute("href")\r\n      }\r\n      var linkedId = element.getAttribute("ccid");\r\n      //binding onclick to popup comp\r\n      element.onclick = function (e) {\r\n       e.stopPropagation(); e.preventDefault();\r\n        var modal = document.querySelector(\`[data-id = \${linkedId}]\`);\r\n        modal.style.display = "block";\r\n        var close = document.querySelector(\`[data-id = \${linkedId}] .close\`);\r\n        close.onclick = function () {\r\n          e.preventDefault();\r\n          modal.style.display = "none";\r\n        };\r\n      };\r\n    });\r\n   /* $(document).on("click", "[href]", (evt) => {\r\n      evt.preventDefault();\r\n    let _link = evt.currentTarget.getAttribute("href");\r\n    // go to particular slide\r\n    com.veeva.clm.gotoSlide("slide2.zip", 12344556);\r\n    });*/\r\n\r\n    // Zepto\r\n    Zepto(function ($) {\r\n      // console.log("Ready to Zepto!");\r\n    });\r\n\r\n    // pinch zoom\r\n    /* var el = document.querySelector("div.pinch-zoom");\r\n    new PinchZoom.default(el, {}); */
// 
  document.querySelectorAll('[data-popup-id]').forEach(btn => {
    btn.addEventListener('click', () => {
      const popupId = btn.getAttribute('data-popup-id');
      const popup = document.getElementById(popupId);
      if (popup) popup.style.display = 'block';
    });
  });`;
  //'const elements = document.querySelectorAll("[ccid]");\r\n    elements.forEach(function (element) {\r\n      if (element.hasAttribute("href")) {\r\n        element.removeAttribute("href")\r\n      }\r\n      var linkedId = element.getAttribute("ccid");\r\n      //binding onclick to popup comp\r\n      element.onclick = function (e) {\r\n        e.preventDefault();\r\n        var modal = document.querySelector(`[data-id = ${linkedId}]`);\r\n        modal.style.display = "block";\r\n        var close = document.querySelector(`[data-id = ${linkedId}] .close`);\r\n        close.onclick = function () {\r\n          e.preventDefault();\r\n          modal.style.display = "none";\r\n        };\r\n      };\r\n    });\r\n   /* $(document).on("click", "[href]", (evt) => {\r\n      evt.preventDefault();\r\n      let _link = evt.currentTarget.getAttribute("href");\r\n      // go to particular slide\r\n      com.veeva.clm.gotoSlide("slide2.zip", 12344556);\r\n    });*/\r\n\r\n    (function () {\r\n      function cida_swipedLeft() {\r\n        // go to prev slide by default\r\n        document.location = "veeva:prevSlide()";\r\n      }\r\n\r\n      function cida_swipedRight() {\r\n        // go to next slide by default\r\n        document.location = "veeva:nextSlide()";\r\n      }\r\n\r\n      function cida_swipedUp() { }\r\n\r\n      function cida_swipedDown() { }\r\n\r\n      window.addEventListener("swipeleft", cida_swipedLeft);\r\n      window.addEventListener("swiperight", cida_swipedRight);\r\n      window.addEventListener("swipeup", cida_swipedUp);\r\n      window.addEventListener("swipedown", cida_swipedDown);\r\n    })();\r\n\r\n    // Zepto\r\n    Zepto(function ($) {\r\n      // console.log("Ready to Zepto!");\r\n    });\r\n\r\n    // pinch zoom\r\n    /* var el = document.querySelector("div.pinch-zoom");\r\n    new PinchZoom.default(el, {}); */';
export const mandatScript ='';
  //'(function () {\r\n      function cida_swipedLeft() {\r\n        // go to prev slide by default\r\n        document.location = "veeva:prevSlide()";\r\n      }\r\n\r\n      function cida_swipedRight() {\r\n        // go to next slide by default\r\n        document.location = "veeva:nextSlide()";\r\n      }\r\n\r\n      function cida_swipedUp() { }\r\n\r\n      function cida_swipedDown() { }\r\n\r\n      window.addEventListener("swipeleft", cida_swipedLeft);\r\n      window.addEventListener("swiperight", cida_swipedRight);\r\n      window.addEventListener("swipeup", cida_swipedUp);\r\n      window.addEventListener("swipedown", cida_swipedDown);\r\n    })();\r\n\r\n    // Zepto\r\n    Zepto(function ($) {\r\n      // console.log("Ready to Zepto!");\r\n    });';
